import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/maestro.vue
var o = {
	name: "DtIconMaestro",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--maestro"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Maestro",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("rect", {
			x: ".25",
			y: "3.75",
			width: "23.5",
			height: "16.5",
			rx: "1.75",
			fill: "#fff",
			stroke: "#E3E5E8",
			"stroke-width": ".5"
		}, null, -1),
		r("path", {
			d: "M13.358 11.733c0 2.615-2.095 4.734-4.679 4.734S4 14.347 4 11.734C4 9.118 6.095 7 8.68 7c2.583 0 4.678 2.12 4.678 4.733Z",
			fill: "#ED0006"
		}, null, -1),
		r("path", {
			d: "M19.429 11.733c0 2.615-2.095 4.734-4.68 4.734-2.584 0-4.679-2.12-4.679-4.733C10.07 9.118 12.165 7 14.75 7c2.584 0 4.679 2.12 4.679 4.733Z",
			fill: "#0099DF"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M11.714 8.13a4.745 4.745 0 0 1 1.644 3.603 4.745 4.745 0 0 1-1.644 3.603 4.745 4.745 0 0 1-1.644-3.603c0-1.442.638-2.734 1.644-3.602Z",
			fill: "#6C6BBD"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=maestro.js.map